<template>
    <v-container fluid grid-list-xl>
        <v-layout wrap>
            <v-flex xs12>
                <h2 class="heading">Diseases</h2>
                <p class="signup-subheading">select from one of these possible causes</p>
            </v-flex>

            <v-flex xs12 d-flex>
                <v-list>
                    <template v-for="item in symptom.availableDiagnosis">
                        <v-list-tile :key="item.Name" @click="select(item)">
                            <v-list-tile-content>
                                <v-list-tile-title v-html="item.Issue.Name"></v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-divider/>
                    </template>
                </v-list>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import priaid from '@/lib/priaid/Client'
    import {mapState, mapGetters} from 'vuex'

    export default {
        data() {
            return {}
        },
        computed: {
            ...mapState(['symptom'])
        },
        methods: {
            select(item) {
                EventBus.$emit('symptom-diagnosis-selected', item);
            }
        },
        mounted() {
            Loading.hide()
        }
    }
</script>